module.exports = __webpack_public_path__ + "img/pr-3.6b4fadf0.png";